export const LOCALIZATION_KEY = 'reporting-create';
export const SECTIONS_SETTINGS_KEY = 'SECTIONS_SETTINGS';
//export const SECTIONS_LAYOUT_KEY = 'SECTIONS_LAYOUT';
//export const DEFAULT_TEMPLATE_KEY = 'DEFAULT_TEMPLATE';
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd-HH-mm';
export const ASC_DIRECTION = 'asc';
export const DESC_DIRECTION = 'desc';
